var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"8/Check"},React.createElement("path",{"id":"Vector 94 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M7.45923 1.54036C7.71307 1.7942 7.71307 2.20575 7.45923 2.45959L3.45923 6.4596C3.20539 6.71344 2.79383 6.71344 2.53999 6.4596L0.53999 4.45959C0.286149 4.20575 0.286149 3.7942 0.53999 3.54036C0.793831 3.28652 1.20539 3.28652 1.45923 3.54036L2.99961 5.08074L6.53999 1.54036C6.79383 1.28652 7.20539 1.28652 7.45923 1.54036Z","fill":"#676D73"})));
}

Check.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = Check;

Check.default = Check;
